import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getDataSpedNormative,
	getDataSpedRestrictionsByNMBahia,
	getConcession,
	getRisksMaster,
} from '../dataSped/thunk';

export const initialState = {
	itemDataSpedList: [],
	itemNMBahia: null,
	itemConcession: null,
	itemRisksMaster: null,
	isDataSpedLoading: false,
	isDataSpedSuccess: false,

	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const DataSpedSlice = createSlice({
	name: 'DataSped',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getDataSpedNormative.pending, state => {
			state.isDataSpedSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getDataSpedNormative.fulfilled, (state, action) => {
			state.itemDataSpedList = action.payload;
			state.isLoadingList = false;
			state.isDataSpedSuccess = true;
		});
		builder.addCase(getDataSpedNormative.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDataSpedSuccess = true;
		});


		
		builder.addCase(getDataSpedRestrictionsByNMBahia.pending, state => {
			state.isDataSpedSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getDataSpedRestrictionsByNMBahia.fulfilled, (state, action) => {
			state.itemNMBahia = action.payload;
			state.isLoadingList = false;
			state.isDataSpedSuccess = true;
		});
		builder.addCase(getDataSpedRestrictionsByNMBahia.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDataSpedSuccess = true;
		});

		builder.addCase(getConcession.pending, state => {
			state.isDataSpedSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getConcession.fulfilled, (state, action) => {
			state.itemConcession = action.payload;
			state.isLoadingList = false;
			state.isDataSpedSuccess = true;
		});
		builder.addCase(getConcession.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDataSpedSuccess = true;
		});

		builder.addCase(getRisksMaster.pending, state => {
			state.isDataSpedSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getRisksMaster.fulfilled, (state, action) => {
			state.itemRisksMaster = action.payload;
			state.isLoadingList = false;
			state.isDataSpedSuccess = true;
		});
		builder.addCase(getRisksMaster.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDataSpedSuccess = true;
		});

	},
});

export const { setRequireCloseModal } = DataSpedSlice.actions;

export default DataSpedSlice.reducer;
